import { GERMAN_POSTAL_CODE_REGEX } from 'cpool-utils';

export const GERMAN_POSTAL_CODE_ERROR_KEY = 'ADDRESS.ZIP_CODE_INVALID';

export const isGermanPostalCode = (value: string | null | undefined) =>
    value == null || value === '' || GERMAN_POSTAL_CODE_REGEX.test(value);
